import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container dtwin-overview",
    attrs: {
      "fluid": ""
    }
  }, [_vm.twinCreateDialog ? _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.twinCreateDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.createDigitalTwin')) + "\n    ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "data-cy": "save_create_dt",
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.twinCreateFormValid
          },
          on: {
            "click": _vm.saveAndCreateTwin
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.saveAndCreate')) + "\n      ")])];
      },
      proxy: true
    }], null, false, 1044548047)
  }, [_c(VForm, {
    ref: "createForm",
    model: {
      value: _vm.twinCreateFormValid,
      callback: function ($$v) {
        _vm.twinCreateFormValid = $$v;
      },
      expression: "twinCreateFormValid"
    }
  }, [_c(VOverlay, {
    attrs: {
      "value": _vm.twinCreateDialog && _vm.isCreatingTwin
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "10",
      "size": "90",
      "rotate": "-90"
    }
  })], 1), !_vm.createTwinWithTemplate ? _c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "dtwin_title",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "rules": [_vm.requiredRule],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.createTwinObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.createTwinObject, "title", $$v);
      },
      expression: "createTwinObject.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.titleDigitalTwinHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "data-cy": "parental_Object",
      "objectFilter": d => d.tenantId === _vm.createTwinObject.tenantId && !_vm.get(d, 'properties.disabled'),
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.createTwinObject.tenantId,
      "required": "",
      "sameTenant": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.createTwinObject.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.createTwinObject, "parentId", $$v);
      },
      expression: "createTwinObject.parentId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.parentDigitalTwinHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "data-cy": "reuse_ParentScope",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.reuseParentScope'),
      "color": _vm.color,
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.createTwinObject.reuseParentScope,
      callback: function ($$v) {
        _vm.$set(_vm.createTwinObject, "reuseParentScope", $$v);
      },
      expression: "createTwinObject.reuseParentScope"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.reuseParentScopeText')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-feature-flag', {
    attrs: {
      "flag": "rd-8391-twin-templates"
    }
  }, [_c(VSwitch, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.createWithTemplate'),
      "hide-details": ""
    },
    model: {
      value: _vm.createTwinWithTemplate,
      callback: function ($$v) {
        _vm.createTwinWithTemplate = $$v;
      },
      expression: "createTwinWithTemplate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.createTwinWithTemplate ? _c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "dtwin_title",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "rules": [_vm.requiredRule],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.createTwinObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.createTwinObject, "title", $$v);
      },
      expression: "createTwinObject.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.titleDigitalTwinHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "data-cy": "twin_template",
      "objectFilter": d => d.tenantId === _vm.createTwinObject.tenantId && !_vm.get(d, 'properties.disabled'),
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.selectTemplate'),
      "placeholder": _vm.$i18n_t('DigitalTwin.DigitalTwin.selectTemplate'),
      "tenantId": _vm.createTwinObject.tenantId,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.createTwinObject.parentId,
      callback: function ($$v) {
        _vm.$set(_vm.createTwinObject, "parentId", $$v);
      },
      expression: "createTwinObject.parentId"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.selectTemplateHint')))])], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-feature-flag', {
    attrs: {
      "flag": "rd-8391-twin-templates"
    }
  }, [_c(VSwitch, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.createWithTemplate'),
      "hide-details": ""
    },
    model: {
      value: _vm.createTwinWithTemplate,
      callback: function ($$v) {
        _vm.createTwinWithTemplate = $$v;
      },
      expression: "createTwinWithTemplate"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('core-csv-export-dialog-multi', {
    attrs: {
      "isOpen": _vm.showExportDialog,
      "type": "digitalTwin"
    },
    on: {
      "close": function ($event) {
        _vm.showExportDialog = false;
      }
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.digitalTwins.head'),
      "subtitle": _vm.$i18n_t('Common.digitalTwins.headInfo')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "data-cy": "dt_csv_export",
            "color": _vm.color,
            "prepend-icon": "fa-file-csv"
          },
          on: {
            "click": function ($event) {
              _vm.showExportDialog = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "data-cy": "dt_list",
            "color": _vm.color,
            "prepend-icon": "fa-list-ul"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push('/digitaltwin-mgmt/list');
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.listView')) + "\n      ")])];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "two-cols-dynamic-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('core-n20Card', {
    staticStyle: {
      "margin-top": "60px"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "data-cy": "dt_fav",
            "title": _vm.$i18n_t('Common.home.favorites'),
            "color": _vm.color,
            "solid-icon": _vm.favouriteFilter,
            "prepend-icon": "fa-star"
          },
          on: {
            "click": function ($event) {
              _vm.initialActiveDtwinId = null;
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }), !_vm.isMobile ? _c('core-button', {
          attrs: {
            "data-cy": "add_newDt",
            "disabled": !_vm.selected || _vm.selected.properties && _vm.selected.properties.disabled,
            "color": _vm.color,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.createTwin(_vm.selected);
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n          ")]) : _c('core-button', {
          attrs: {
            "data-cy": "add_newDt",
            "disabled": !_vm.selected || _vm.selected.properties && _vm.selected.properties.disabled,
            "color": _vm.color,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.createTwin(_vm.selected);
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "data-cy": "search_dtwin",
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "keydown": function ($event) {
        _vm.initialActiveDtwinId = null;
      }
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('core-dtwin-tree-default', {
    key: _vm.counter,
    ref: "twin-tree",
    attrs: {
      "favourites": _vm.favouriteFilter,
      "activeDtwinId": _vm.initialActiveDtwinId,
      "searchTerm": _vm.search,
      "openTreeNodes": _vm.open,
      "canSelectDisabledTwins": "",
      "cached": "",
      "loadFullDtwinData": ""
    },
    on: {
      "onSelectedChange": _vm.didSelectTwin,
      "initialDtwins": _vm.loadedInitialDtwins
    }
  })], 1)], 1), _c(VRow, [_vm.treeLoading ? _c(VCol, {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 30,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  }), _c('h6', {
    staticClass: "category grey--text mt-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.digitalTwins.loadingTwins')) + "\n            ")])], 1) : _vm._e()], 1)], 1)], 1), _c(VCol, {
    staticClass: "two-cols-dynamic-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6",
      "lg": "8"
    }
  }, [_vm.selected ? _c('core-dtwin-detail', {
    attrs: {
      "dtwin": _vm.selected
    },
    on: {
      "create-twin": _vm.createTwin,
      "delete-twin": _vm.deleteTwin
    }
  }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };